<template>
  <div class="bodydiv">
    <!-- <el-row>上海体育文史资料数据库</el-row> -->
    <!-- <el-row> -->
    <el-row class="mainbox">
      <el-row type="flex" justify="center" align="middle">
        <p id="title">党校微课堂</p>
      </el-row>
      <br />
      <br />
      <el-row type="flex" justify="center" align="middle" style="margin-top:-10px;">
        <p id="subtitle">后台管理平台</p>
      </el-row>
      <el-row type="flex" justify="center" align="middle" style="margin-top:20px;">
        <el-card class="box-card login-card">
          <div slot="header" class="header">
            <p class="paragraph-title-main">登录</p>
          </div>

          <!-- <el-select v-model="value" filterable placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>-->

          <div v-if="!isPhone">
            <el-row class="main">
              <el-row type="flex" justify="start" align="middle" class="login-row">
                <p class="login-form-title grey">用户名：</p>
              </el-row>
              <el-row type="flex" justify="start" align="middle" class="login-row">
                <el-input
                  v-model="username"
                  placeholder="请输入用户名"
                  class="input-comp"
                  suffix-icon="el-icon-info"
                >
                  <!-- <i slot="suffix" class="el-icon-info"></i> -->
                </el-input>
              </el-row>
              <el-row type="flex" justify="start" align="middle" class="login-row">
                <p class="login-form-title grey">密码：</p>
              </el-row>
              <el-row type="flex" justify="start" align="middle" class="login-row">
                <el-input
                  v-model="password"
                  type="password"
                  placeholder="请输入密码"
                  class="input-comp"
                  suffix-icon="el-icon-edit"
                  @keyup.enter.native="login"
                >
                  <!-- <i slot="suffix" class="el-icon-edit"></i> -->
                </el-input>
              </el-row>
              <el-row v-if="error != null">
                <div class="error-div">
                  <p class="paragraph-content-small red">{{error}}</p>
                </div>
              </el-row>
            </el-row>
            <el-row style="padding-top:15px;">
              <div class="handlediv">
                <el-button
                  type="primary"
                  class="btn-login"
                  @click="login"
                  :loading="loading"
                  style="width:300px;"
                >登录</el-button>
                <!-- <el-button class="btn-forget" @click="forget">忘记密码</el-button> -->
              </div>
            </el-row>
          </div>
          <!-- 手机验证码登陆 -->
          <div v-if="isPhone">
            <el-row class="main">
              <el-row type="flex" justify="start" align="middle" class="login-row">
                <p class="login-form-title grey">手机号：</p>
              </el-row>
              <el-row type="flex" justify="start" align="middle" class="login-row">
                <el-input
                  v-model="userPhone"
                  placeholder="请输入手机号"
                  class="input-comp"
                  suffix-icon="el-icon-info"
                >
                  <!-- <i slot="suffix" class="el-icon-info"></i> -->
                </el-input>
              </el-row>
              <el-row type="flex" justify="start" align="middle" class="login-row">
                <p class="login-form-title grey">验证码：</p>
              </el-row>
              <el-row type="flex" justify="start" align="middle" class="login-row">
                <el-input v-model="codeText" type="type" placeholder="请输入验证码" class="input-comp">
                  <template slot="append">
                    <div @click="getCode" class="getCode">{{getCodeText}}</div>
                  </template>
                </el-input>
              </el-row>
              <el-row v-if="error != null">
                <div class="error-div">
                  <p class="paragraph-content-small red">{{error}}</p>
                </div>
              </el-row>
            </el-row>
            <el-row style="padding-top:15px;">
              <div class="handlediv">
                <el-button
                  type="primary"
                  class="btn-login"
                  @click="phoneLogin"
                  :loading="loading"
                  style="width:300px;"
                >登录</el-button>
                <!-- <el-button class="btn-forget" @click="forget">忘记密码</el-button> -->
              </div>
            </el-row>
          </div>
          <!-- <span class="changeButton" @click="changePage">{{changeText}}</span> -->
          <el-row type="flex" justify="center" align="middle">
            <el-button type="text" class="btn-login" @click="forget">忘记密码</el-button>
          </el-row>
        </el-card>
      </el-row>
      <el-row type="flex" justify="center" align="middle" style="margin-top:20px;">
        <p id="lasttitle">党校微课堂 版权所有</p>
      </el-row>
      <el-row type="flex" justify="center" align="middle" style="margin-top:5px;">
        <p id="lasttitle">为了更好的使用体验，建议使用Chrome等主流浏览器</p>
      </el-row>
    </el-row>

    <!-- </el-row> -->
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { getCodeApi, phoneLoginApi } from "@/api/module/login/telLogin";

export default {
  name: "Login",
  
  data() {
    return {
      value: "",
      username: "",
      password: "",
      error: "",
      loading: false,
      redirect: "",
      isPhone: false,
      getCodeText: "获取验证码",
      changeText: "手机验证码登录",
      userPhone: "", // 手机号
      codeText: "", // 验证码
      canClick: true
    };
  },
  
  methods: {
    // 映射Vuex的action
    ...mapActions('profileModule', ['LoginByUsername']),
    
    login() {
      if (this.username == null || this.username.length == 0) {
        this.error = "请填写用户名！";
        return;
      }
      
      this.loading = true;
      
      const lf = {
        u: this.username,
        p: this.password,
      };
      
      this.LoginByUsername(lf)
        .then(() => {
          console.log("登陆成功");
          this.$router.push({ path: "/" });
        })
        .catch((error) => {
          console.log("error", error);
          // this.$message.error("账号已锁定，请联系管理员修改密码");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    // 使用手机验证码登陆
    phoneLogin() {
      let phone = this.userPhone;
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        this.error = "手机号码有误，请重填！";
        return false;
      }
      if (!this.codeText) {
        this.error = "请输入验证码！";
        return false;
      }
      let code = this.codeText;
      let data = {
        phone,
        code,
      };
      phoneLoginApi(data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.error(res.message);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    
    forget() {
      this.$alert("请直接联系管理人员获得密码！", "忘记密码", {
        showConfirmButton: false,
        closeOnClickModal: true,
      });
    },
    
    // 更改登录方式
    changePage() {
      this.isPhone = !this.isPhone;
      this.error = "";
      if (!this.isPhone) {
        this.changeText = "手机验证码登录";
      }
      if (this.isPhone) {
        this.changeText = "用户名密码登录";
      }
    },
    
    // 获取验证码
    getCode() {
      let phone = this.userPhone;
      if (!/^1[3456789]\d{9}$/.test(phone)) {
        this.error = "手机号码有误，请重填！";
        return false;
      }
      if (this.canClick) {
        this.canClick = false;
        // 验证码接口
        getCodeApi(phone)
          .then((res) => {
            console.log(123, res);
          })
          .catch((error) => {
            console.log(error);
          });
        this.getCodeText = 60;
        let CodeInterval = setInterval(() => {
          if (this.getCodeText > 0) {
            this.getCodeText -= 1;
          } else {
            clearInterval(CodeInterval);
            this.canClick = true;
            this.getCodeText = "重新获取验证码";
          }
        }, 1000);
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.changeButton {
  display: block;
  color: #767676;
  position: absolute;
  z-index: 1001;
  right: 20%;
  bottom: 33%;
}
.changeButton:hover {
  color: #409eff;
  cursor: pointer;
}
/* 获取验证码 */
.getCode {
  width: 98px;
  text-align: center;
}
.getCode:hover {
  cursor: pointer;
}

.login-card {
  width: 360px;
  height: 490px;
  /* width: 60%; */
  /* max-width: 700px; */
  /* min-width: 350px; */
}

.mainbox {
  margin: auto auto;
  margin-top: 70px;
  padding-bottom: 120px;
  width: 500px;
}

.login-card .header {
  height: 10px;
  line-height: 0px;
  text-align: center;
}

.login-card .main {
  height: 250px;
  padding-top: 20px;
  padding-left: 10px;
  padding-right: 10px;
  /* margin-top: 30px; */
  /* margin-bottom: 50px; */
}

.login-title {
  width: 15%;
  min-width: 80px;
  max-width: 120px;
  text-align: right;
  margin-right: 30px;
}

.input-comp {
  /* width: 50%; */
  min-width: 260px;
  max-width: 300px;
}

.bodydiv {
  position: relative;
  width: 100%;
  /* height: 100%; */
  min-height: 100%;
  /* background: url("https://shsportshistory.oss-cn-hangzhou.aliyuncs.com/shsportshistory/login.jpg"); */
  /* display: flex;
  justify-content: center; */
  /* align-items: center; */
  /* text-align: center; */
  position: absolute;
  display: flex;
  background: url("login.jpg") no-repeat;
  background-size: 100% 100%;
  background-position: center;
  /* flex-direction: row; */
}

.handlediv {
  padding-top: 30px;
  border-top: 1px solid #ebeef5;
  display: flex;
  justify-content: center;
  align-items: center;
}

.error-div {
  text-align: center;
}

/* .login-row { */
/* padding-right: 40px; */
/* } */

#title {
  color: white;
  font-weight: bold;
  font-size: 36px;
  line-height: 0px;
}

#subtitle {
  color: white;
  font-size: 24px;
  line-height: 0px;
}

#lasttitle {
  color: white;
  font-size: 14px;
  line-height: 0px;
  opacity: 0.5;
}

.login-form-title {
  font-size: 14px;
  font-family: "Microsoft YaHei", "微软雅黑", "Helvetica Neue", Helvetica,
    "PingFang SC", "Hiragino Sans GB", Arial, sans-serif;
}

.login-card .tips {
  padding-top: 10px;
  /* font-size: 13px; */
}

.tips p {
  font-size: 13px;
}
</style>
